const Number = ({ value, decimals = 0 }) => {
    return Intl.NumberFormat('en-GB', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(value)
}

export default Number
